import script from "./Marital_Status.vue?vue&type=script&setup=true&lang=js"
export * from "./Marital_Status.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__